export default __webpack_public_path__ + "static/girl-675fae63610f0996439845480bfa53e8.webp";